import { render, staticRenderFns } from "./ConnectedAs.vue?vue&type=template&id=970d9390&"
import script from "./ConnectedAs.vue?vue&type=script&lang=ts&"
export * from "./ConnectedAs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports